<template>
  <div class="min-h-screen">
    <!-- what used to be WideContainer in Pastrami -->
    <div class="flex justify-center">
      <div class="min-w-[320px] max-w-[1920px] grow">
        <slot />
      </div>
    </div>
  </div>

  <div id="toast-wrapper" class="fixed z-50">
    <TheToast to="#toast-wrapper" />
  </div>
  <CookiesModal />
</template>

<script setup lang="ts">
import { useHead } from '#imports'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import TheToast from '@backmarket/nuxt-module-toast/TheToast.vue'
import CookiesModal from '@backmarket/nuxt-module-tracking/CookiesModal.vue'
import { toRfc4646Locale } from '@backmarket/utils/string/toRfc4646Locale'

import translations from './default.translations'

const lang = toRfc4646Locale(useI18nLocale())
const i18n = useI18n()

useHead({
  title: i18n(translations.pageTitle),
  htmlAttrs: {
    lang,
  },
})
</script>
